export default __webpack_public_path__ + "static/media/ETH.3c7946eb.svg";